// TODO -- see if we can combine with ChangeEmail component.
// That is, make a single component where properties are passed in
// to determine if it's for password or email.

// https://mui.com/material-ui/react-dialog/#form-dialogs

import * as React from 'react';

import KeyIcon from '@mui/icons-material/Key';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import TokenService from "src/services/token";
import { useNavigate } from "react-router-dom";

import {
    setUserMessage
} from 'src/reducers/basicReducer';
import { useDispatch } from 'react-redux'

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useFormik } from "formik";

import * as yup from "yup";

import { change_password } from "src/services/auth"

const validationSchema = yup.object({
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    password_old: yup
        .string()
        .min(8, 'Password should be of minimum 8 characters length')
        .required('Current password is required'),
    password_new: yup
        .string()
        .min(8, 'Password should be of minimum 8 characters length')
        .required('New password is required'),
    password_repeat: yup
        .string()
        .min(8, 'Password should be of minimum 8 characters length')
        .required('Please retype your password.')
        .oneOf([yup.ref('password_new')], 'Your passwords do not match.')
});


export default function ChangePassword() {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const [message, setMessage] = React.useState("");

    const handleClose = () => {
        setOpen(false);
        setMessage("");
    };


    const formik = useFormik({

        initialValues: {
            email: '',
            password_old: '',
            password_new: '',
            password_repeat: ''
        },
        validationSchema: validationSchema,
        // TODO - consider if we should have two password fields (and check that they match)
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            console.log(values);

            change_password(values.email, values.password_old, values.password_new).then(
                () => {
                    // XXX dispatch(setUserMessage("Registration successful. Please log in."));
                    // XXX navigate("/login");
                    setMessage("Password change successful");
                    // TODO - consider if we should log out users at this point

                    // TODO - consider if we should clear all form fields at this point (probably, lol)
                    // https://bobbyhadz.com/blog/react-clear-input-after-submit
                },
                (error) => {
                    console.log("Password change failed!!!");
                    console.log(error);

                    // resMessage is for if we want to automatically determine the issue to display
                    // const resMessage =
                    //     (error.response &&
                    //         error.response.data &&
                    //         error.response.data.message) ||
                    //     error.message ||
                    //     error.toString();
                    // setLoading(false);
                    if (error.response.data.status === "bad email or current password") {
                        setMessage("Error: invalid email or current password");
                    } else {
                        setMessage("Unknown error");
                    }
                }
            );
        }
    });











    return (




        <div>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
                Open form dialog
            </Button> */}
            <ListItemButton onClick={handleClickOpen}>
                <ListItemIcon>
                    <KeyIcon />
                </ListItemIcon>
                <ListItemText primary="Change password" />
            </ListItemButton>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Change password</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To change your account password, please fill out this form.
                    </DialogContentText>

                    <Box
                        component="form"
                        id="myform"
                        onSubmit={formik.handleSubmit}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        {/* TODO: think about how to reserve space for helperText
                        so the form does not expand and contract as we work
                        on it https://github.com/mui/material-ui/issues/13646 */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            name="email"
                            label="Email Address"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="password_old"
                            name="password_old"
                            label="Current password"
                            type="password_old"
                            value={formik.values.password_old}
                            onChange={formik.handleChange}
                            error={formik.touched.password_old && Boolean(formik.errors.password_old)}
                            helperText={formik.touched.password_old && formik.errors.password_old}
                        />

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="password_new"
                            name="password_new"
                            label="New password"
                            type="password"
                            value={formik.values.password_new}
                            onChange={formik.handleChange}
                            error={formik.touched.password_new && Boolean(formik.errors.password_new)}
                            helperText={formik.touched.password_new && formik.errors.password_new}
                        />

                        {/* TODO - check "type" and other properties are set correctly. For type, we use "password"
so it shows up as dots. https://stackoverflow.com/questions/60391113/how-to-view-password-from-material-ui-textfield

Optional TODO - could add  a visibility switch for password fields https://www.geeksforgeeks.org/how-to-show-and-hide-password-in-reactjs/ */}

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="password_repeat"
                            name="password_repeat"
                            label="Repeat new password"
                            type="password"
                            value={formik.values.password_repeat}
                            onChange={formik.handleChange}
                            error={formik.touched.password_repeat && Boolean(formik.errors.password_repeat)}
                            helperText={formik.touched.password_repeat && formik.errors.password_repeat}
                        />

                        {/* TODO: move style to css! */}

                        {/* {message && (
                            <div className="form-group">
                                <div className="alert alert-danger" role="alert" style={{ color: 'red' }}>
                                    {message}
                                </div>
                            </div>
                        )} */}

                        {/* https://stackoverflow.com/questions/63721055/react-hooks-remember-me-checkbox-in-login-form-not-working */}
                        {/* <FormControlLabel
                            control={<Checkbox id="remember" name="remember" value={formik.values.remember} onChange={formik.handleChange} color="primary" />}
                            label="Remember me"
                        /> */}
                        {/* <Button
                            type="submit"
                            onClick={() => {
                                // erase user message if new submission is attempted
                                // https://stackoverflow.com/questions/61962001/how-to-make-the-formik-call-a-function-when-the-form-is-invalid
                                // dispatch(setUserMessage(""))
                            }}
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button> */}
                    </Box>



                </DialogContent>
                {/* https://stackoverflow.com/questions/40881616/how-to-submit-the-form-by-material-ui-dialog-using-reactjs */}
                <DialogActions>

                    {/* TODO - elsewhere redux message is wrapped in another div (???) Maybe drop the outer div? */}
                    {message && (
                        <div className="alert alert-danger" role="alert" style={{ flex: '1 0 0', color: 'red' }}>
                            {message}
                        </div>
                    )}

                    <Button variant="contained" type="submit" form="myform">Submit</Button>
                    <Button variant="contained" onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}